module.exports = __webpack_public_path__ + "img/timetable.29541f09.svg";